import React from 'react';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { Button, ConfigProvider, Table } from 'tea-component';
import useReviewReplyData from '@/pages/opinion/components/ReviewsModal/useReviewReplyData';
import { sentimentRenderList } from '@/pages/opinion/components/ReviewsModal/constants';
import { getTeaLocale } from '@/pages/home/utils/lang';
import { getLocale } from 'umi';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import CardSentiment from '@op/pages/accounts/widgets/AccountsCard/Sentiment';
import { useDownloadParams } from '@op/hooks/useDownloadParams';
import { useSplitGptSummary } from '@op/components/GPT/hooks/useSplitGptSummary';
const { sortable, scrollable, autotip } = Table.addons;

const SentimentTable = ({
  data,
  gameInfo,
  userInfo,
  language,
  wholeGameInfo,
  maxHeight = 845,
  setTableLoading
}: any) => {
  const { Sentiment_Update, Sentiment_Rating } = useGetSingePageSourceRule({
    keys: ['Sentiment_Update', 'Sentiment_Rating'],
  });

  const {
    pageInfoAddons,
    noData,
    tableCommon,
    sentimentInfo,
    loading,
    setSort,
    sort,
    formatMessage,
    tableList,
    total,
    filter,
  } = useReviewReplyData({
    itemData: data,
    gameInfo,
    userInfo,
    language,
    text: 'Go to',
    showSentiment: !Sentiment_Update,
    setTableLoading
  });

  const { downloadLegacy, downloading } = useDownloadParams();

  const downloadTable = () => {
    const downloadLimit = 150000;
    if (!total) return;
    const params = {
      page: 1,
      page_size: 100,
    };
    const downLoadParams = {
      ...data,
      user_id: userInfo.userid,
      is_valid: 0,
      sort_model: sort.by,
      sort: sort.order,
      language,
      ...gameInfo,
      ...params,
      hideSentimentRating: Sentiment_Rating,
    };

    downloadLegacy({
      total,
      limit: downloadLimit,
      params: downLoadParams,
      downloadFunc: 'getFeedsDetails',
      sheetName: 'Post Reviews',
      simpleName: 'Post Reviews',
    });
  };
  const locale = getTeaLocale(getLocale());

  const { GptElement, GptBtnElement } = useSplitGptSummary({
    filter,
    gameInfo,
    hasAdvancedSummary: true,
    total,
    scenario: 'sub_comments',
  });

  return (
    <>
      {tableList.length > 0 && (
        <div className="dbo-sentiment-table-header">
          <div className="dbo-sentiment-table-header-left">
            <CardSentiment
              sentimentsData={sentimentInfo}
              className="dbo-keywordbox-sentimentbox-border"
            ></CardSentiment>
          </div>
          <div className="dbo-sentiment-table-operate">
            {GptBtnElement}
            <Button
              className="dbo-sentiment-table-download-icon"
              loading={downloading}
              onClick={downloadTable}
            >
              <SvgIcon type="download" />
            </Button>
          </div>
        </div>
      )}
      {GptElement}
      <div className="dbo-sentiment-table">
        {data.list ? (
          <div className="dbo-sentiment-table-title">
            <span className="dbo-sentiment-title">
              {formatMessage({ id: 'Sentiment' })}
            </span>
            {sentimentRenderList.map(({ key, icon }) => {
              return (
                <div className="dbo-sentiment-text" key={key}>
                  {/* <Bubble dark content={e.content}> */}
                  <SvgIcon type={icon} className="dbo-sentiment-icon" />
                  {/* </Bubble> */}
                  {noData ? 0 : sentimentInfo[key]}%
                </div>
              );
            })}
          </div>
        ) : null}
        <ConfigProvider locale={locale}>
          <Table
            className="dbo-sentiment-table-context"
            verticalTop
            records={tableList}
            recordKey={(record: any) => record?.comment_uin}
            bordered
            columns={tableCommon}
            addons={[
              ...pageInfoAddons,
              sortable({
                columns: [
                  {
                    key: 'comment_time',
                    prefer: 'desc',
                  },
                  {
                    key: 'tweets_like',
                    prefer: 'desc',
                  },
                  {
                    key: 'engagement',
                    prefer: 'desc',
                  },
                ],
                value: [sort],
                onChange: (value) => {
                  setSort(
                    value?.[0] || {
                      by: 'comment_time',
                      order: 'desc',
                    },
                  );
                },
              }),
              scrollable({
                maxHeight,
              }),
              autotip({
                isLoading: loading,
                emptyText: formatMessage({
                  id: 'Comments on this post have not yet been crawled.',
                }),
                loadingText: '',
              }),
            ]}
          />
        </ConfigProvider>
      </div>
    </>
  );
};

export default SentimentTable;
